
const formatDate = function (strDate) {
  let date = new Date(strDate)
    let y = date.getFullYear()
    let m = date.getMonth() + 1
    let d = date.getDate()
    return `${y}年${m}月${d}日`
}

const formatDateTime = function (strDate) {
  let date = new Date(strDate)
    let y = date.getFullYear()
    let m = date.getMonth() + 1
    let d = date.getDate()
    let h = formatTimeValue(date.getHours())
    let min = formatTimeValue(date.getMinutes())
    let sec = formatTimeValue(date.getSeconds())
    return `${y}年${m}月${d}日 ${h}:${min}:${sec}`
}

const formatTimeValue = function (val) {
  return (val < 10) ? ('0' + val) : val
}

/*
 * テキストをHTMLとして解釈不可となるようにエスケープします。
 */
const sanitize = function (text) {
  if (!text) return ''
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
    .replace(/`/g, '&#96')
}

/*
 * テキストをサニタイズしてからURLをaタグに、改行文字を<br>に置換します。
 */
const prepareLongTextValue = function (value) {
  if (!value) return ''
  let text = sanitize(value)
  return autoLink(text).split('\n').join('<br>')
}

/*
 * テキスト内URLをaタグに置換します。
 */
const autoLink = function (value) {
  if (!value) return ''
  return value.replace(/(https?:\/\/[^\s]*)/g, "<a href='$1' target='_blank'>$1</a>")
}

export default {
  formatDate,
  formatDateTime,
  prepareLongTextValue,
  autoLink
}



// WEBPACK FOOTER //
// ./app-common-vue/src/lib/Utils.js